/**
 * Bien-Etre PDP interactions
 * - Hero: variant chips, purchase toggle (Loop-ready shell)
 * - FAQ accordion
 * - Upsell AJAX add-to-cart → cart page
 */
(function () {
  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format || Shopify.money_format);
    }
    // Fallback: apply theme/shop money format (usually includes currency symbol + placement).
    // This prevents losing the currency symbol when Shopify.formatMoney isn't present.
    var amount = (cents / 100).toFixed(2);
    if (!format) return amount;

    // Create a simple thousands separator variant for common Shopify placeholders.
    var parts = amount.split('.');
    var intPart = parts[0];
    var decPart = parts[1] || '';
    var withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (decPart ? '.' + decPart : '');

    if (format.indexOf('{{amount_no_decimals}}') !== -1) {
      var noDec = String(Math.round(cents / 100));
      return format.replace('{{amount_no_decimals}}', noDec);
    }

    if (format.indexOf('{{amount_with_comma_separator}}') !== -1) {
      return format.replace('{{amount_with_comma_separator}}', withThousands);
    }

    if (format.indexOf('{{amount}}') !== -1) {
      return format.replace('{{amount}}', amount);
    }

    return amount;
  }

  function initHero(section) {
    initFaq(section);
    initGallery(section);

    var form = section.querySelector('[data-be-pdp-product-form]');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    var variantsJson = section.querySelector('[data-be-pdp-variants-json]');
    if (!variantsJson || !variantInput) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      return;
    }

    var priceMain = section.querySelector('[data-be-pdp-price-main]');
    var priceSave = section.querySelector('[data-be-pdp-price-save]');
    var submitBtn = form.querySelector('[type="submit"][name="add"]');
    var submitSpan = submitBtn && submitBtn.querySelector('span');

    var onetimeLabel = section.dataset.priceLabelOnetime || '';
    var subscribeLabel = section.dataset.priceLabelSubscribe || '';
    var atcTemplate = section.dataset.atcTemplate || 'Add to Cart';
    var moneyFormat = section.dataset.moneyFormat || '';

    function getVariant(id) {
      return variants.find(function (v) {
        return String(v.id) === String(id);
      });
    }

    function setVariant(id) {
      var variant = getVariant(id);
      if (!variant) return;

      variantInput.value = variant.id;
      variantInput.disabled = !variant.available;

      if (priceMain) {
        priceMain.textContent = formatMoney(variant.price, moneyFormat);
      }

      if (submitBtn) {
        if (!variant.available) {
          submitBtn.setAttribute('disabled', 'disabled');
          if (submitSpan) submitSpan.textContent = 'Sold out';
        } else {
          submitBtn.removeAttribute('disabled');
          if (submitSpan) {
            var label = atcTemplate;
            if (label.indexOf('[price]') !== -1) {
              label = label.replace('[price]', formatMoney(variant.price, moneyFormat));
            }
            submitSpan.textContent = label;
          }
        }
      }

      section.querySelectorAll('[data-be-pdp-variant-chip]').forEach(function (chip) {
        chip.classList.toggle('is-active', chip.dataset.variantId === String(variant.id));
      });

      section.dispatchEvent(
        new CustomEvent('be-pdp:variant-change', { bubbles: true, detail: { variant: variant } })
      );
    }

    section.querySelectorAll('[data-be-pdp-variant-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        setVariant(chip.dataset.variantId);
      });
    });

    var toggleBtns = section.querySelectorAll('[data-be-pdp-purchase-toggle]');
    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.dataset.bePdpPurchaseToggle;
        toggleBtns.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        if (priceSave) {
          priceSave.textContent = mode === 'subscribe' ? subscribeLabel : onetimeLabel;
        }
        /* Loop subscription widget hooks in here when live */
        section.dispatchEvent(
          new CustomEvent('be-pdp:purchase-mode-change', { bubbles: true, detail: { mode: mode } })
        );
      });
    });

    var initial = variantInput.value || (variants[0] && variants[0].id);
    if (initial) setVariant(initial);
  }

  function initGallery(section) {
    var mediaJson = section.querySelector('[data-be-pdp-media-json]');
    var main = section.querySelector('[data-be-pdp-main-media]');
    var gallery = section.querySelector('[data-be-pdp-gallery]');
    if (!mediaJson || !main) return;

    var media = [];
    try {
      media = JSON.parse(mediaJson.textContent);
    } catch (e) {
      return;
    }
    if (!media.length) return;

    var index = 0;

    function renderMedia(i) {
      index = (i + media.length) % media.length;
      var item = media[index];
      if (!item) return;

      var alt = String(item.alt || '').replace(/"/g, '&quot;');
      var src = item.src || item.preview;

      if (item.type === 'video') {
        main.innerHTML =
          '<video class="be-pdp-hero__main-img be-pdp-hero__main-img--video" autoplay loop muted playsinline poster="' +
          item.preview +
          '"><source src="' +
          src +
          '"></video>';
      } else {
        main.innerHTML =
          '<img class="be-pdp-hero__main-img be-pdp-hero__main-img--photo" src="' +
          src +
          '" alt="' +
          alt +
          '" loading="lazy">';
      }

      section.querySelectorAll('[data-be-pdp-gallery-dot]').forEach(function (dot, dIndex) {
        var active = dIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    var prev = section.querySelector('[data-be-pdp-gallery-prev]');
    var next = section.querySelector('[data-be-pdp-gallery-next]');
    if (prev) prev.addEventListener('click', function () { renderMedia(index - 1); });
    if (next) next.addEventListener('click', function () { renderMedia(index + 1); });

    section.querySelectorAll('[data-be-pdp-gallery-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.dataset.mediaIndex, 10);
        if (!isNaN(i)) renderMedia(i);
      });
    });

    if (gallery && media.length > 1) {
      var touchStartX = 0;
      var touchDelta = 0;

      gallery.addEventListener(
        'touchstart',
        function (event) {
          if (!event.changedTouches || !event.changedTouches.length) return;
          touchStartX = event.changedTouches[0].clientX;
          touchDelta = 0;
        },
        { passive: true }
      );

      gallery.addEventListener(
        'touchmove',
        function (event) {
          if (!event.changedTouches || !event.changedTouches.length) return;
          touchDelta = event.changedTouches[0].clientX - touchStartX;
        },
        { passive: true }
      );

      gallery.addEventListener(
        'touchend',
        function () {
          if (Math.abs(touchDelta) < 40) return;
          if (touchDelta < 0) renderMedia(index + 1);
          else renderMedia(index - 1);
          touchDelta = 0;
        },
        { passive: true }
      );
    }

    var initialIndex = 0;
    var activeDot = section.querySelector('[data-be-pdp-gallery-dot].is-active');
    if (activeDot) {
      var parsed = parseInt(activeDot.dataset.mediaIndex, 10);
      if (!isNaN(parsed)) initialIndex = parsed;
    }
    renderMedia(initialIndex);
  }

  function setFaqPanelOpen(panel, open) {
    if (!panel) return;
    if (open) {
      panel.classList.add('is-open');
      panel.removeAttribute('hidden');
    } else {
      panel.classList.remove('is-open');
      panel.setAttribute('hidden', '');
    }
  }

  function initFaq(section) {
    if (section.dataset.bePdpFaqInit === 'true') return;
    section.dataset.bePdpFaqInit = 'true';

    section.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-be-pdp-faq-trigger]');
      if (!trigger || !section.contains(trigger)) return;

      var item = trigger.closest('[data-be-pdp-faq-item]');
      var panel = item && item.querySelector('[data-be-pdp-faq-panel]');
      if (!panel) return;

      var isOpen = trigger.getAttribute('aria-expanded') === 'true';

      section.querySelectorAll('[data-be-pdp-faq-trigger]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      section.querySelectorAll('[data-be-pdp-faq-panel]').forEach(function (p) {
        setFaqPanelOpen(p, false);
      });

      if (!isOpen) {
        trigger.setAttribute('aria-expanded', 'true');
        setFaqPanelOpen(panel, true);
      }
    });
  }

  function initUpsell(section) {
    var btn = section.querySelector('[data-be-pdp-upsell-atc]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');

      var cartAdd =
        (window.routes && window.routes.cart_add_url) ||
        (window.Shopify && Shopify.routes && Shopify.routes.root + 'cart/add.js') ||
        '/cart/add.js';

      fetch(cartAdd, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (data.status && data.description) {
            throw new Error(data.description);
          }
          var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
          window.location.href = cartUrl;
        })
        .catch(function (err) {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
          if (window.alert) window.alert(err.message || 'Could not add to cart.');
        });
    });
  }

  function initFinalCta(section) {
    var btn = section.querySelector('[data-be-pdp-final-atc]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var hero = document.querySelector('[data-be-pdp-hero]');
      var heroForm = hero && hero.querySelector('[data-be-pdp-product-form]');
      if (heroForm) {
        var submit = heroForm.querySelector('[type="submit"][name="add"]');
        if (submit && !submit.disabled) {
          submit.click();
          return;
        }
      }
      var url = btn.dataset.productUrl;
      if (url) window.location.href = url;
    });
  }

  function initSection(section) {
    if (section.matches('[data-be-pdp-hero]')) initHero(section);
    else if (section.matches('[data-be-pdp-faq]')) initFaq(section);
    if (section.matches('[data-be-pdp-upsell]')) initUpsell(section);
    if (section.matches('[data-be-pdp-final]')) initFinalCta(section);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-be-pdp-hero], [data-be-pdp-faq], [data-be-pdp-upsell], [data-be-pdp-final]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });
})();
